import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { PwaService } from 'src/app/services/pwa.service';
import { ApiService } from 'src/app/services/api.service';
import { ToastService } from 'src/app/services/toast.service';
import { ApiInit } from 'src/app/utils/api-init';
import { Browser } from '@capacitor/browser';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import {
  IonContent,
  IonHeader,
  IonRippleEffect,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { DivClickDirective } from 'src/app/directives/div-click.directive';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  standalone: true,
  imports: [
    NgIf,
    RouterLink,
    TranslateModule,
    DivClickDirective,
    IonContent,
    IonHeader,
    IonRippleEffect,
    IonToolbar,
    IonTitle,
  ],
})
export class SettingsPage implements OnInit {
  version: string;
  showPermissions: boolean = false;
  truncatedClientSecret: string;
  isProjectApp: boolean = false;
  showLogin: boolean = false;
  whiteLabelText: string = '';

  constructor(
    private settingsService: SettingsService,
    private pwaService: PwaService,
    private app: CurrentWhiteLabelApplication,
    private apiService: ApiService,
    private toastService: ToastService,
    private apiInit: ApiInit
  ) {
    this.isProjectApp = this.app.isProjectApp();
    this.whiteLabelText = this.app.getCompanyText();
    this.showLogin = this.app.isLoginEnabled();
  }

  ngOnInit() {
    if (!this.pwaService.isPwa()) this.showPermissions = true;
    this.getAppVersion();
    this.apiInit.watch(async () => {
      this.truncatedClientSecret = this.apiService.getTruncatedClientSecret();
    });
  }

  async getAppVersion() {
    this.version = await this.settingsService.getAppVersion();
  }

  async openPrivacyStatement() {
    Browser.open({
      url: this.settingsService.getPriavacyStatementUrl(this.app.getPlatform()),
    });
  }

  async openEula() {
    Browser.open({
      url: this.settingsService.getEulaUrl(this.app.getPlatform()),
    });
  }

  async copy() {
    await navigator.clipboard.writeText(this.truncatedClientSecret);
    await this.toastService.show('page.settings.secret.copied');
  }
}
